/**
 * [스마트검색] React Query Key Factory
 */
export const smartSearchKeys = {
  all: ['smart-search'] as const,

  /** 자주 묻는 질문 목록 (GET /smart-search/frequent-questions) */
  frequentQuestions: () => [...smartSearchKeys.all, 'frequentQuestions'] as const,

  /** 스마트 검색 (GET /smart-search?query=) */
  search: (query: string) => [...smartSearchKeys.all, 'search', query] as const,
};
